<template>
  <div>
    <div class="homepage">
      <div class="d-inline">
        <topbar class="homepage__topbar" id="topBar" />
      </div>
      <div class="container carousel-style">
        <div
          id="carouselExampleCaptions"
          class="carousel slide slide-style"
          data-ride="carousel"
        >
          <ol class="carousel-indicators">
            <li
              data-target="#carouselExampleCaptions"
              data-slide-to="0"
              class="active"
            ></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
                :height="bannerSize"
                src="@/assets/images/home/baner/industry_chain.png"
                class="d-block m-auto"
                alt="wait..."
              />
            </div>
            <div class="carousel-item">
              <img
                :height="bannerSize"
                src="@/assets/images/home/baner/peta.png"
                class="d-block m-auto"
                alt="wait.."
              />
            </div>
          </div>
          <a
            class="carousel-control-prev"
            href="#carouselExampleCaptions"
            role="button"
            data-slide="prev"
          >
            <span
              ><img
                width="20"
                src="@/assets/images/home/baner/arrow/arrow-left.svg"
            /></span>
            <span class="sr-only">Previous</span>
          </a>
          <a
            class="carousel-control-next"
            href="#carouselExampleCaptions"
            role="button"
            data-slide="next"
          >
            <span
              ><img
                width="20"
                src="@/assets/images/home/baner/arrow/arrow-right.svg"
              />
            </span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>

      <!-- testing card -->
      <div id="testingLab" class="container category-lab">
        <div class="col-md-3 mb-3">
          <h4 class="laboratory-list">Pengujian</h4>
        </div>
        <div class="row">
          <div class="col-md-12 p-0">
            <img
              @click="gotoPrev2"
              src="@/assets/images/back.png"
              class="slick-prev custom-icon"
            />

            <VueSlickCarousel v-bind="settings" ref="carousel2">
              <div
                v-for="(item, index) in TestingList"
                :key="index"
                class="container"
              >
                <div
                  @click="searchLab(item.search, 'testing')"
                  class="card shadow mb-5 bg-white"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Beta version, nantikan update brikutnya"
                >
                  <img
                    height="60"
                    class="img-category rounded"
                    :src="getImgUrl('testing', item.image)"
                    :alt="item.name"
                  />
                  <div class="card-body text-center text-height">
                    <h6
                      class="text-list__style"
                      :class="{ 'd-block text-truncate': isMobile }"
                    >
                      {{ item.name }}
                    </h6>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
            <img
              @click="gotoNext2"
              src="@/assets/images/next.png"
              class="slick-next custom-icon"
            />
          </div>
        </div>
      </div>

      <!-- calibration cards -->
      <div id="calibrationLab" class="container">
        <div class="col-md-3">
          <h4 class="laboratory-list">Kalibrasi</h4>
        </div>
        <div class="row list-calibration">
          <div class="col-md-12 mb-5 p-0">
            <img
              @click="gotoPrev"
              src="@/assets/images/back.png"
              class="slick-prev custom-icon"
            />
            <VueSlickCarousel v-bind="settings" ref="carousel1">
              <div
                v-for="(item, index) in calibrationList"
                :key="index"
                class="container"
              >
                <div
                  @click="searchLab(item.search, 'calibration')"
                  class="card shadow mb-5 bg-white"
                >
                  <img
                    height="60"
                    class="img-category rounded"
                    :src="getImgUrl('Kalibrasi', item.image)"
                    :alt="item.name"
                  />
                  <div class="card-body text-center text-height">
                    <h6
                      class="text-list__style "
                      :class="{ 'd-block text-truncate': isMobile }"
                    >
                      {{ item.name }}
                    </h6>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
            <img
              @click="gotoNext"
              src="@/assets/images/next.png"
              class="slick-next custom-icon"
            />
          </div>
        </div>
      </div>

      <div class="text-center">
        <h1 class="title-activity__main">Bisa apa saja di LabFolder ?</h1>
        <h5 class="title-activity">
          Akses database laboratorium kalibrasi dan pengujian terlengkap di
          Indonesia
        </h5>
      </div>
      <div class="container mb-5">
        <div class="card-activity">
          <div class="card-activity__item card zoom shadow mb-5 bg-white">
            <div
              @click="searchLab('standard', 'calibration')"
              class="card-body"
            >
              <div class="row">
                <div class="type-lab">
                  <img
                    class="card-activity__icon"
                    src="@/assets/images/home/speedometer.svg"
                  />
                </div>
                <div class="col-md-8 ml-3">
                  <h2 class="card-activity__title">Kalibrasi</h2>
                  <small
                    >Memuat kelompok pengukuran, jenis alat ukur/standar,
                    rentang ukur dan ketidakpastian.
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card-activity__item card zoom
             card-activity__second-section shadow bg-white"
          >
            <div @click="searchLab('pengujian', 'testing')" class="card-body">
              <div class="row">
                <div class="type-lab">
                  <img
                    class="card-activity__icon"
                    src="@/assets/images/home/measuring.svg"
                  />
                </div>
                <div class="col-md-8 ml-3">
                  <h2 class="card-activity__title">Pengujian</h2>
                  <small
                    >Memuat obyek uji, jenis pengujian dan metode ujinya.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="jumbotron jumbotron-fluid bg-white feature-section">
        <div class="container">
          <div class="text-center mb-5">
            <h1>Fitur apa saja di LabFolder ?</h1>
            <h5 class="title-activity">
              Pencarian laboratorium pengujian dan kalibrasi, bookmark, dan
              kontak laboratorium
            </h5>
          </div>
          <div class="container">
            <div class=" card-activity">
              <div class="card-activity__action">
                <div
                  @click="scrollToForm('topBar')"
                  class="card card__features-mobile zoom shadow mb-5 bg-white"
                  style="width: 18rem;"
                >
                  <div class="card-body text-center">
                    <img
                      class="ml-4 card-activity__action--icon"
                      src="@/assets/images/home/file.svg"
                    />
                    <h4
                      class="card-title font-weight-bold card-activity__action--title"
                    >
                      Pencarian Lab
                    </h4>

                    <p class="text-muted">
                      Pencarian berdasarkan kata kunci pencarian
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-activity__action">
                <div
                  class="card card__features-mobile zoom shadow mb-5 bg-white"
                  style="width: 18rem;"
                >
                  <div @click="Bookmark" class="card-body text-center ">
                    <img
                      class="ml-1 card-activity__action--icon"
                      src="@/assets/images/home/bookmark.svg"
                    />
                    <h4
                      class="card-title font-weight-bold card-activity__action--title"
                    >
                      Bookmark
                    </h4>

                    <p class="text-muted">
                      Bookmark dari hasil pecarian database
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-activity__action">
                <div
                  @click="scrollToForm('footerHome')"
                  class="card card__features-mobile zoom shadow mb-5 bg-white"
                  style="width: 18rem;"
                >
                  <div class="card-body text-center ">
                    <img
                      class="ml-1 card-activity__action--icon"
                      src="@/assets/images/home/call.svg"
                    />
                    <h4
                      class="card-title font-weight-bold card-activity__action--title"
                    >
                      Kontak
                    </h4>

                    <p class="text-muted">
                      Menu kontak kepada penyedia layanan
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="jumbotron mt-4 mb-4 bg-white certificate">
          <div class="container box-content">
            <div class=" higlight">
              <img
                class="iso-image"
                src="@/assets/images/home/iso-image.jpeg"
                alt=""
                srcset=""
              />
            </div>
            <div class="higlight">
              <h1 class="display-4">Apa itu akreditasi ISO 17025?</h1>
              <p class="lead mt-4">
                ISO / IEC 17025: 2017 merupakan standar ISO yang digunakan oleh
                Laboratorium yang merupakan persyaratan umum untuk kompetensi
                laboratorium pengujian dan kalibrasi.
              </p>
              <a
                class="btn btn-lg mt-4 main-color"
                href="https://www.iso.org/ISO-IEC-17025-testing-and-calibration-laboratories.html"
                role="button"
                target="_blank"
                >Selengkapnya</a
              >
            </div>
          </div>
        </div>
      </div>
      <myfooter id="footerHome" />
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import topbar from "../../components/home/topbar.vue";
import myfooter from "../../components/home/footer.vue";
import VueSlickCarousel from "vue-slick-carousel";
import mixinLabData from "../../mixins/mixinLabData";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "home",
  data: () => ({
    settings: {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      initialSlide: 0,
      arrows: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: 3,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true,
          },
        },
      ],
    },
    Token: "",
  }),

  components: {
    topbar,
    VueSlickCarousel,
    myfooter,
  },

  mixins: [mixinLabData],

  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },

    bannerSize() {
      return this.isMobile ? 200 : 400;
    },
  },

  methods: {
    ...mapMutations(["setDataSearch"]),

    gotoNext() {
      this.$refs.carousel1.next();
    },
    gotoPrev() {
      this.$refs.carousel1.prev();
    },
    gotoNext2() {
      this.$refs.carousel2.next();
    },
    gotoPrev2() {
      this.$refs.carousel2.prev();
    },

    getImgUrl(type, imagePath) {
      if (type === "testing") {
        return require("@/assets/images/slider/" + imagePath);
      } else {
        return require("@/assets/images/slider/calibration/" + imagePath);
      }
    },

    Bookmark: function() {
      if (this.Token) {
        this.$router.push({ path: "/userDashbord/bookmark" });
        window.scroll(0, 0);
      } else {
        this.$router.push({ path: "/login/" });
        window.scroll(0, 0);
      }
    },
    enquery: function() {},

    scrollToForm: function(elmentId) {
      document.getElementById(elmentId).scrollIntoView({ behavior: "smooth" });
    },

    searchLab: function(searchKeyword, labType) {
      let data = {
        keywords: searchKeyword,
      };
      this.setDataSearch(data);
      this.$router.push({ path: `/result?lab=${labType}` });
    },

    handleAlertMobile() {
      if (window.innerWidth < 480) {
        return;
      }
    },
  },

  created() {
    this.Token = window.$cookies.get("ACCESS_PRV");
  },
};
</script>
<style scoped src="@/assets/css/home.css" />

<style lang="scss" scoped>
::v-deep {
  @media (max-width: 768px) {
    .slick-dots {
      position: relative;
      bottom: 0;
    }

    .slick-next {
      display: none;
    }

    .img-category {
      width: 50%;
      margin: auto;
    }
  }
}

.text-height {
  position: relative;
  top: -10px;
}

.text-list__style {
  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.custom-icon:hover {
  scale: 1.1;
}

.card {
  border-radius: 14px;
  height: 150px;
  width: 150px;
  padding: 0.25rem !important;

  @media (max-width: 768px) {
    height: 110px;
    width: 110px;
    padding: 16px 0 !important;
  }

  &__features-mobile {
    @media (max-width: 768px) {
      height: 140px;
    }
  }
}

.title-activity {
  font-size: 1.25rem;

  @media (max-width: 768px) {
    padding: 0 4px;
    font-size: medium;
    font-weight: normal;
    padding: 0 16px;
  }

  &__main {
    @media (max-width: 768px) {
      font-size: 28px;
      margin-bottom: 10px;
      padding: 0 16px;
    }
  }
}

.card-activity {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  &__item {
    width: 475px;
    margin-top: 20px;
    @media (max-width: 768px) {
      height: auto;
    }

    @media (max-width: 768px) {
      padding-top: 46px !important;
    }

    @media (max-width: 540px) {
      margin-bottom: 30px;
      padding-top: 46px !important;
    }
  }
  &__action {
    flex-wrap: unset;

    @media (min-width: 768px) and (max-width: 850px) {
      margin-bottom: 150px;
    }

    @media (max-width: 768px) {
      margin-bottom: 30px;
    }

    &--icon {
      @media (max-width: 768px) {
        width: 46px;
        margin-bottom: -15px;
      }
    }

    &--title {
      margin-top: 60px;
      @media (max-width: 768px) {
        margin: 24px 0 40px;
      }
    }
  }

  &__icon {
    width: 120px;

    @media (max-width: 768px) {
      position: relative;
      bottom: 20px;
      left: 90px;
      width: 96px;
    }
  }

  &__second-section {
    @media (max-width: 768px) {
      margin-top: 0;
    }
  }

  &__title {
    @media (max-width: 768px) {
      position: absolute;
      bottom: 80px;
    }
  }
}

.feature-section {
  @media (max-width: 768px) {
    position: relative;
    top: -30px;
  }
}

.type-lab {
  @media (max-width: 768px) {
    margin: 0 auto -18px;
  }
}

.category-lab {
  margin-bottom: 40px;
  margin-top: 45px;

  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
}

.box-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 70px auto;

  @media (max-width: 768px) {
    margin: 0 auto;
  }
}

.iso-image {
  border-radius: 42px;
  width: 350px;

  @media (max-width: 768px) {
    margin: auto;
    width: 300px;
  }
}

.list-calibration {
  margin-bottom: 100px;

  @media (max-width: 768px) {
    margin-bottom: 2px;
  }
}

.higlight {
  width: 535px;
  @media (max-width: 768px) {
    margin-bottom: 80px;
  }
}

.slide-style {
  position: relative;
  top: 82px;
  margin-bottom: -30px;

  @media (max-width: 768px) {
    top: 12px;
    margin-bottom: 0px;
  }
}

.certificate {
  @media (max-width: 768px) {
    margin: 0 !important;
    padding: 0;
    text-align: center;
  }
}
</style>
